import { FunctionComponent } from "react";

import dynamic from "next/dynamic";

import { TextFieldWithCopyProps } from "./types";

// Disabled SSR to avoid memory leak caused by makeStyles
export const TextFieldWithCopy = dynamic(
  () => import("./TextFieldWithCopySsr").then((mod) => mod.TextFieldWithCopySsr),
  {
    ssr: false,
  }
) as FunctionComponent<TextFieldWithCopyProps>;
